import React from "react";
import CardClass from "../../../CardClass";
import EmptyState from "../../../EmptyState";
import MUIButton from "@mui/material/Button";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import MUISwitch from "@mui/material/Switch";
import MUIIconButton from "@mui/material/IconButton";
import MUIAddIcon from "@mui/icons-material/Add";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUIGrid from "@mui/material/Grid";
import DialogSearchOrderStatus from "../../../Dialog/Search/DialogSearchOrderStatus";
import TileOrderStatus from "../../../Tile/TileOrderStatus";
import PropTypes from "prop-types";
import OrderStatus from "../../../../Utility/Crud/OrderStatus";
import MainContext from "../../../../Context/MainContext/MainContext";

export default class CardAdminQueueFilterOrderActivityOrderStatus extends CardClass {
    static contextType = MainContext; // For legacy class components

    constructor(props) {
        super(props);

        this.state.orderStatusDialogOpen = false;
    }

    /**
     * Render the content of the card.
     */
    renderContent() {
        const handleRemove = (orderStatus) => {
            const filter = this.props.queue.filter;
            if (!filter["order_activity.status"]?.properties?.value) {
                return;
            }
            filter["order_activity.status"].properties.value = filter["order_activity.status"].properties.value.filter((entry) => entry !== orderStatus);
            if (filter["order_activity.status"].properties.value.length === 0) {
                delete filter["order_activity.status"];
            }

            this.props.onChange({
                "filter": filter
            });
        };

        const values = this.props.queue?.filter?.["order_activity.status"]?.properties?.value || [];

        const excludeChecked = this.props.queue?.filter?.["order_activity.status"]?.properties?.operator === "not in";

        const handleExcludeToggle = (event) => {
            const filter = this.props.queue.filter;
            filter["order_activity.status"].properties.operator = event.target.checked ? "not in" : "in";

            this.props.onChange({
                "filter": filter
            });
                };

        if (values.length > 0) {
            return (
                <>
                    <MUIFormControlLabel
                        sx={{ marginLeft: 0 }}
                        control={<MUISwitch color="error" checked={excludeChecked} onChange={handleExcludeToggle} />}
                        label="Exclude"
                    />
                    <MUIGrid container spacing={2}>
                        {values.map((orderStatusId) => {
                            const orderStatus = OrderStatus.read(
                                this.context.orderStatusesIndexed,
                                [{
                                    "key": "id",
                                    "value": orderStatusId
                                }]
                            )[0];
                            return (
                                <MUIGrid key={orderStatusId} item xs={12} sm={6} md={4}>
                                    <TileOrderStatus
                                        orderStatus={orderStatus}
                                        iconButtons={[(<MUIIconButton onClick={() => handleRemove(orderStatusId)}><MUIDeleteIcon /></MUIIconButton>)]}
                                    />
                                </MUIGrid>
                            );
                        })}
                        {this.renderDialog()}
                    </MUIGrid>
                </>
            );
        } else {
            return (
                <>
                    <EmptyState
                        line1="Not Configured"
                        line2="Showing all Order Statuses"
                    />
                    {this.renderDialog()}
                </>
            );
        }
    }

    /**
     * Renders a search dialog of Order Status
     */
    renderDialog() {
        const handleAdd = (orderStatus) => {
            const filter = (this.props.queue && this.props.queue.filter) || {};
            if (!filter["order_activity.status"]) {
                filter["order_activity.status"] = {
                    type: "set",
                    properties: {
                        operator: "in",
                        value: [],
                    },
                };
            }
            filter["order_activity.status"].properties.value = [...new Set([...(filter["order_activity.status"].properties.value || []), orderStatus.id])];

            this.props.onChange({
                "filter": filter
            });
        };

        return (
            <DialogSearchOrderStatus
                open={this.state.orderStatusDialogOpen}
                onClose={() => this.setState({ orderStatusDialogOpen: false })}
                onSelect={handleAdd}
            />
        );
    }

    /**
     * Renders add Order Statu button
     */
    getActions() {
        const handleAdd = () => {
            this.setState({
                orderStatusDialogOpen: true,
            });
        };

        const buttonItems = [(<MUIButton
                component="label"
                variant="outlined"
                startIcon={<MUIAddIcon />}
                onClick={handleAdd}>Add Order Status</MUIButton>)
        ];

        return buttonItems;
    }

    /**
     * @returns {string} The title of the card.
     */
    getTitle() {
        return "Filter: Order Activity > Order Status";
    }
}